import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './RequstedProvider.sass'
import Avatar, { Badge } from 'components/Avatar'
import Member from 'iam/models/Member'
import Tooltip from 'components/Tooltip'
import { truncate } from 'lodash'

interface Props {
  provider: Member
}

export default observer(function CollaboratorItem({ provider }: Props) {
  return (
    <div
      className={cx(
        styles.root,
        provider.email && styles.withEmail,
        provider.phone && styles.withPhone
      )}
    >
      <div className={styles.info}>
        <p className={styles.title}>{provider.displayName}</p>
        <div className={styles.subtitle}>
          <div className={styles.subtitleInfo}>
            {provider.email && (
              <>
                {provider.email.length >= 38 ? (
                  <Tooltip content={provider.email}>
                    <p className={styles.email}>
                      {truncate(provider.email, { length: 38 })}
                    </p>
                  </Tooltip>
                ) : (
                  <p className={styles.email}>{provider.email}</p>
                )}
              </>
            )}
            {provider.phone && <p className={styles.phone}>{provider.phone}</p>}
          </div>
        </div>
        <div className={styles.footer}>
          <p>
            <span className={styles.pro}>Requested Provider</span>
          </p>

          <div className={styles.avatarContainer}>
            <Avatar
              badge={provider.user.online ? Badge.Online : Badge.Offline}
              size={32}
              subject={provider}
            />
          </div>
        </div>
      </div>
    </div>
  )
})
